export default "__VITE_ASSET__dc724116__"